/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-17 11:20:28
 * @LastEditTime: 2025-09-04 10:00:07
 */
import docSvg from './img/pdf.svg';
export const hardLabelArr = ['官方自营', '正品保障', '增票速开', '售后保障', '包邮'];
export const sdkLabelArr = ['官方自营','正品保障','增票速开','售后保障','云交付']
export const softLabelArr = ['官方自营','正品保障','增票速开','售后保障'];
 // 购买流程
 export const buyData = [
  {
    id: 1,
    title: '提交订单',
  },
  {
    id: 2,
    title: '支付成功',
  },
  {

    id: 3,
    title: '下载软件包',
  },
  {

    id: 3,
    title: '<span style="position:relative;left:-30px;">激活授权<span style="position:absolute;width:65px;">(仅专业版)</span><span>',
  },
  {
    id: 3,
    title: '正式使用',
  }
 ];

 export const serviceSupport = [
   {
     id: 1,
     type:1,
     title: '开发手册',
     icon:docSvg,
   },
   {
     id: 2,
     type:2,
     title: '服务内容',
     desc1:'产品免费热线服务<br/>远程技术支持',
    //  desc2:'远程技术支持',
   },
   
   {
     id: 3,
     type:2,
     title: '服务条款',
      desc1: '订购此商品即为您同意<br/>《服务支持条款》',
    //  desc2: '《服务支持条款》',
      // TODO：链接暂时没有
    link: 'https://show.originqc.com.cn/prod/quantum_cloud/webAppAssetsFiles/assets/files/pdf/%E7%94%A8%E6%88%B7%E4%BF%A1%E6%81%AF%E6%9C%8D%E5%8A%A1%E6%9D%A1%E6%AC%BE.pdf'
  }
 ]